const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "";
const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID || "";
const GTM_ID = process.env.REACT_APP_GTM_ID || "";
const GTAG_SCRIPT_ID = "ibp-google-gtag";
const GTM_SCRIPT_ID = "ibp-google-tag-manager";

let initialized = false;

const trackingIds = [GA_ID, ADS_ID].filter(Boolean);

function ensureDataLayer() {
  if (typeof window === "undefined") return null;
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };
  return window.gtag;
}

function loadGtagScript(id) {
  if (!id || typeof document === "undefined") return;
  if (document.getElementById(GTAG_SCRIPT_ID)) return;

  const script = document.createElement("script");
  script.id = GTAG_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  document.head.appendChild(script);
}

function loadGtmScript(id) {
  if (!id || typeof document === "undefined") return;
  if (document.getElementById(GTM_SCRIPT_ID)) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });

  const script = document.createElement("script");
  script.id = GTM_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(id)}`;
  document.head.appendChild(script);
}

export function initGoogleTracking() {
  if ((!trackingIds.length && !GTM_ID) || initialized) return;
  const gtag = ensureDataLayer();
  if (!gtag) return;

  if (GTM_ID) loadGtmScript(GTM_ID);

  if (trackingIds.length) {
    loadGtagScript(trackingIds[0]);
    gtag("js", new Date());

    trackingIds.forEach((id) => {
      gtag("config", id, {
        send_page_view: false,
        linker: {
          domains: ["illinoisbrokerprep.com", "illinoisbrokerprep.store"],
        },
      });
    });
  }

  initialized = true;
}

export function trackPageView(pathname, title) {
  if (!trackingIds.length && !GTM_ID) return;
  initGoogleTracking();
  const gtag = ensureDataLayer();
  if (!gtag) return;

  window.dataLayer.push({
    event: "page_view",
    page_title: title || document.title,
    page_location: window.location.href,
    page_path: pathname || window.location.pathname,
  });

  gtag("event", "page_view", {
    page_title: title || document.title,
    page_location: window.location.href,
    page_path: pathname || window.location.pathname,
  });
}

export function trackGoogleEvent(eventName, params = {}) {
  if (!trackingIds.length && !GTM_ID) return;
  initGoogleTracking();
  const gtag = ensureDataLayer();
  if (!gtag) return;
  window.dataLayer.push({ event: eventName, ...params });
  gtag("event", eventName, params);
}
